export class KolumnaImportuEwidencji {
    czyImportowac: boolean;
    kolumnaEwidencji: string;
    poleSpisuId: string;
    priorytetParowania?: number;
}